import * as types from './types';

export default {

  openSnackbar({ commit }, payload) {
    commit(types.OPEN_SNACKBAR, payload);
  },
  closeSnackbar({ commit }, payload) {
    commit(types.CLOSE_SNACKBAR, payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/app/actions.js